var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQnaLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91675 12.25H4.08341C3.43883 12.25 2.91675 11.7279 2.91675 11.0833V6.41667C2.91675 5.77208 3.43883 5.25 4.08341 5.25H9.91675C10.5613 5.25 11.0834 5.77208 11.0834 6.41667V11.0833C11.0834 11.7279 10.5613 12.25 9.91675 12.25Z",
    stroke: "#C2C4C8",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 9.96921V8.45837",
    stroke: "#C2C4C8",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30948 7.71151C7.48034 7.88237 7.48034 8.15938 7.30948 8.33023C7.13863 8.50109 6.86162 8.50109 6.69076 8.33023C6.51991 8.15938 6.51991 7.88237 6.69076 7.71151C6.86162 7.54066 7.13863 7.54066 7.30948 7.71151",
    stroke: "#C2C4C8",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 5.25V4.08333V4.08333C4.66675 2.79475 5.7115 1.75 7.00008 1.75V1.75C8.28867 1.75 9.33342 2.79475 9.33342 4.08333V4.08333V5.25",
    stroke: "#C2C4C8",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQnaLock);
export default __webpack_public_path__ + "static/media/icon_qna_lock.a71ed4ac8018901312c5d660a65b08e8.svg";
export { ForwardRef as ReactComponent };